const Utils = {};

const providers = {
  orange: /^((237)6((9[0-9]{7})|(5[5-9][0-9]{6})|(8[6-9][0-9]{6})|(4[0-1][0-9]{6})))$/,
  mtn: /^((237)6((7[0-9]{7})|(5[0-4][0-9]{6})|(8[0-4][0-9]{6})))$/,
  camtel: /^((237)(242|243)[0-9]{6})|(62)[0-9]{7}$/,
  nexttel: /^(237)6((6[0-9]{7})|(85[0-9]{6}))$/,
  eum: /^((237)(6([5-9][0-9]{7}))|((242|243)[0-9]{6}))$/,
  all: /^237((6(([5-9][0-9]{7})|(20[0-9]{6})))|((242|243)[0-9]{6})|(62)[0-9]{7}|(64[0-1][0-9]{6}))$/,
};

const defaultFont = "Lato";

const smsStatus = function() {
  return {
    total: 0,
    delivered: 0,
    undelivered: 0
  };
};

const smsProvidersStatus = function() {
  const status = smsStatus();
  return {
    mtn: status,
    ocm: status,
    nex: status,
    ctl: status,
    other: status
  };
};

Utils.install = function(Vue) {
  Utils.setLocaleBCP47 = function(lang) {
    let locale;
    switch (lang) {
      case "fr":
        locale = "fr-FR";
        break;
      default:
        locale = "en-US";
    }
    return locale;
  };

  Utils.validateAccountRole = function(role) {
    return /^(ROLE_ADMIN|ROLE_CLIENT|ROLE_SUPER_ADMIN)$/.test(role);
  };

  Utils.validateBillingType = function(billingType) {
    return /^(PrePaid|PostPaid)$/.test(billingType);
  };

  Utils.validateOperationProvision = function(operation) {
    return /^(credit|debit)$/.test(operation);
  };

  Utils.validateSmsCount = function(value) {
    if (!value === 0) return false;
    return /^[0-9]+$/.test(value);
  };

  Utils.validateNumber = function(value) {
    return /^[0-9]+$/.test(value);
  };

  Utils.validateSenderId = function(value) {
    return /^(([^\s\W_][\s\w\W]{2,11})|([0-9]{1,15}))$/.test(value);
  };

  Utils.linesToArrayNumbers = function(text, onlyLocalPhone = true) {
    let result = {
      invalid: [],
      valid: []
    };
    const valid = new Set();

    if (!text) return result;

    const lines = text.split("\n");
    for (let i = 0; i < lines.length; i++) {
      if (
        lines[i].trim() != "" &&
        lines[i].trim() != null &&
        /^\d+$/.test(lines[i])
      ) {
        if (onlyLocalPhone) {
          if (providers.all.test(lines[i])) {
            valid.add(lines[i]);
          } else {
            result.invalid.push({ text: lines[i], line: i });
          }
        } else {
          valid.add(lines[i]);
        }
      } else {
        result.invalid.push({ text: lines[i], line: i });
      }
    }
    result.valid = Array.from(valid);
    return result;
  };

  Utils.countSms = function(value) {
    if (!value) return 0;
    return Math.ceil(value.length / 160);
  };

  Utils.pad = function pad(num, size) {
    if (parseInt(num) === 0) return 0;
    let s = num + "";
    while (s.length < size) s = "0" + s;
    return s;
  };

  Utils.isSmsSource = function(source) {
    return [
      "api_public",
      "file__bgfi",
      "file__input_bulk",
      "file__csv_bulk",
      "file__sgc_disp",
      "file__sgc_mouv",
      "file__sgc_seui",
      "file__sgc_sold",
      "push_web"
    ].includes(source);
  };

  Utils.truncate = function(fullStr, len, separator) {
    let strLen;

    if (!Array.isArray(len)) len = [len];
    if (/\s+/.test(fullStr)) {
      strLen = len[0];
    } else {
      strLen = len[1] ? len[1] : len[0];
    }

    if (fullStr.length <= strLen) return fullStr;

    separator = separator || "...";

    const sepLen = separator.length;
    const charsToShow = strLen - sepLen;
    const frontChars = Math.ceil(charsToShow / 2);

    return fullStr.substr(0, frontChars) + separator;
  };

  Utils.isValidServerType = function(type) {
    return /^MMG|OZEKI$/.test(type);
  };

  Utils.isValidPort = function(port) {
    if (!/[0-9]{1,5}/.test(port)) return false;

    const val = parseInt(port);
    if (val < 0 || val > 65535) return false;

    return true;
  };

  Utils.isValidIpV4 = function(port) {
    if (
      !/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(
        port
      )
    ) {
      return false;
    }
    const parts = port.split(".").sort((a, b) => a - b);
    return parts[3] <= 255;
  };

  Utils.isValidDirectoryAppName = function(value) {
    return /^[a-z0-9._-]{1,50}$/i.test(value);
  };

  Utils.isValidDirFileNotTreatedSince = function(value) {
    if (!/[0-9]+/.test(value)) return false;
    return parseInt(value) >= 60;
  };

  Utils.isValidDirFileRunningSince = function(value) {
    if (!/[0-9]+/.test(value)) return false;
    return parseInt(value) >= 60;
  };

  Utils.isValidDirFileSizeLimit = function(value) {
    if (!/[0-9]+/.test(value)) return false;
    return parseInt(value) >= 1;
  };

  Utils.isValidDirNotFileDay = function(value) {
    return /^((?:([1-7])(?!.*\2))+)$/.test(value);
  };

  Utils.isValidDirUriAbsolute = function(value) {
    return /^[a-z0-9/:_-]{1,200}$/i.test(value);
  };

  Utils.isValidDirUriRelative = function(value) {
    return /^[a-z0-9/_-]{1,200}$/i.test(value);
  };

  Utils.isValidHour = function(value, format = "HH:mm:ss") {
    const time = Vue.prototype.$moment(value, format, true);
    return time.isValid();
  };

  Utils.isValidEmail = function(value) {
    // eslint-disable-next-line no-useless-escape
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    );
  };

  Utils.getArrayOfDates = function(date) {
    const output = [];
    const startOfMonth = Vue.moment(date).startOf("month");
    const endOfMonth = Vue.moment(date).endOf("month");
    const today = Vue.moment();

    for (
      let m = startOfMonth;
      (m.diff(endOfMonth, "days") < 0 || m.isSame(endOfMonth, "day")) &&
      today.diff(m, "days") > 0;
      m.add(1, "days")
    ) {
      output.push(m.format("YYYY-MM-DD"));
    }

    return output;
  };

  Utils.parseSummaryMessageStats = function(messages) {
    const response = {
      delivered: 0,
      pending: 0,
      total: 0,
      undelivered: 0,
      acked: 0,
      details: {}
    };

    Vue._.each(messages, message => {
      const count = parseInt(message.count);
      if (message.tracking_status) {
        if (message.tracking_status === "DELIVERED") {
          response.delivered += count;
        } else if (message.tracking_status === "PENDING") {
          response.pending += count;
        } else {
          if (
            !Object.prototype.hasOwnProperty.call(
              response.details,
              message.tracking_status
            )
          )
            response.details[message.tracking_status] = 0;
          response.details[message.tracking_status] += count;
        }

        response.acked += count;
      } else {
        response.pending += count;
      }
      if (message.tracking_status !== "DELIVERED") {
        response.undelivered += count;
      }
      response.total += count;
    });
    return response;
  };

  Utils.parseDetailsStats = function(sources) {
    const output = {
      days: {},
      telcos: smsProvidersStatus(),
      total: smsStatus(),
      sources: {}
    };

    Vue._.each(sources, source => {
      if (!Vue._.has(output.days, source.date)) {
        output.days[source.date] = {
          total: smsStatus(),
          telcos: smsProvidersStatus(),
          sources: {}
        };
      }
      // set telco count
      Vue._.each(output.days[source.date].telcos, (val, k) => {
        const count = Utils.setDataTelcoCount(source.total, k);

        output.days[source.date].telcos[k] = count;
        // set total day count
        output.days[source.date].total = Utils.setTotalCount(
          { ...output.days[source.date].total },
          { ...count }
        );
        // set total telcos count
        output.telcos[k] = Utils.setTotalCount(
          { ...output.telcos[k] },
          { ...count }
        );
        // set total count
        output.total = Utils.setTotalCount({ ...output.total }, { ...count });
      });
      // set sources count
      output.days[source.date].sources = source.total.source;
      // set total source;
      output.sources = Utils.setTotalSourceCount(
        { ...output.sources },
        { ...source.total.source }
      );
    });

    return output;
  };

  Utils.parseChartByStatus = function(sources, $translation) {
    const colorsMap = {
      delivered: "#00897B",
      undelivered: "#FF6F00"
    };

    const response = {
      data: [],
      options: {
        pieHole: 0.4,
        colors: [],
        fontSize: 13,
        fontName: defaultFont,
        legend: {
          textStyle: {
            fontName: defaultFont
          }
        },
        titleTextStyle: {
          fontName: defaultFont
        },
        chartArea: {
          left: "3%",
          top: "3%",
          height: "95%",
          width: "95%"
        }
      }
    };
    
    Vue._.each(sources, (value, k) => {
      if (!["delivered", "undelivered"].includes(k)) return;

      const title = $translation(`$vuetify.statistics.model.${k}.title`);
      // values
      response.data.push([title, value]);
      // colors options
      response.options.colors.push(colorsMap[k]);
    });

    // add header
    if (response.data.length > 0) {
      response.data.unshift([
        $translation("$vuetify.statistics.model.status.title"),
        $translation("$vuetify.statistics.model.sms.title")
      ]);
    }

    return response;
  };

  Utils.parseChartByTelco = function(sources, $translation) {
    const response = {
      data: [],
      options: {
        pieHole: 0.4,
        fontSize: 13,
        fontName: defaultFont,
        legend: {
          textStyle: {
            fontName: defaultFont
          }
        },
        tooltip: {
          textStyle: {
            fontName: defaultFont
          }
        },
        titleTextStyle: {
          fontName: defaultFont
        },
        chartArea: {
          left: "3%",
          top: "3%",
          height: "95%",
          width: "95%"
        }
      }
    };

    Vue._.each(sources, (count, telco) => {
      // values
      response.data.push([
        $translation(`$vuetify.telcos.${telco}`),
        count.total
      ]);
    });

    // add header
    if (response.data.length > 0) {
      response.data.unshift([
        $translation("$vuetify.statistics.model.telco.title"),
        $translation("$vuetify.statistics.model.sent.title")
      ]);
    }

    return response;
  };

  Utils.parseChartByStatusAndDays = function(sources, $translation) {
    const response = {
      data: [],
      options: {
        colors: ["#00897B", "#FF6F00", "#1A237E"],
        fontSize: 12,
        fontName: defaultFont,
        chartArea: {
          top: "10%",
          left: "15%",
          height: "55%",
          width: "85%"
        },
        height: 300,
        legend: {
          textStyle: {
            fontName: defaultFont,
            fontSize: 12
          },
          position: "bottom"
        },
        tooltip: {
          textStyle: {
            fontName: defaultFont
          }
        },
        titleTextStyle: {
          fontName: defaultFont
        },
        vAxis: {
          textStyle: {
            fontName: defaultFont,
            fontSize: 12
          },
          titleTextStyle: {
            fontName: defaultFont,
            fontSize: 12
          },
          title: $translation("$vuetify.statistics.model.sms_amount.title")
        },
        hAxis: {
          textStyle: {
            fontName: defaultFont,
            fontSize: 12
          },
          titleTextStyle: {
            fontName: defaultFont,
            fontSize: 12
          },
          title: $translation("$vuetify.statistics.model.date.title")
        }
      }
    };

    Vue._.each(sources, (source, date) => {
      response.data.push([
        date,
        source.total.delivered,
        source.total.undelivered
      ]);
    });

    // add header
    if (response.data.length > 0) {
      response.data.unshift([
        $translation("$vuetify.statistics.model.date.title"),
        $translation("$vuetify.statistics.model.delivered.short_title"),
        $translation("$vuetify.statistics.model.undelivered.short_title")
      ]);
    }

    return response;
  };

  Utils.parseDetailsStatsByAllDay = function(sources, arrayOfDates) {
    const output = {};
    Vue._.each(arrayOfDates, day => {
      if (!Vue._.has(sources, day)) {
        output[day] = {
          sources: {},
          telcos: smsProvidersStatus(),
          total: smsStatus()
        };
      } else {
        output[day] = sources[day];
      }
    });
    return output;
  };

  Utils.exportStatisticByDay = async function(
    date,
    sources,
    total,
    $translation
  ) {
    const workbook = new Vue.$exceljs.Workbook({
      creator: "BulkSMS",
      lastModifiedBy: "BulkSMS",
      created: new Date(),
      modified: new Date()
    });

    const worksheet = workbook.addWorksheet(
      $translation("$vuetify.statistics.details.days.title2", date)
    );

    worksheet.columns = [
      {
        header: $translation("$vuetify.statistics.model.date.title"),
        key: "date",
        style: { numFmt: "yyyy-mm-dd", font: { name: "Calibri", size: 11 } },
        width: 18
      },
      {
        header: $translation("$vuetify.statistics.model.sent.title"),
        key: "total",
        width: 18,
        style: { font: { name: "Calibri", size: 11 } }
      },
      {
        header: $translation("$vuetify.statistics.model.delivered.title"),
        key: "delivered",
        width: 18,
        style: { font: { name: "Calibri", size: 11 } }
      },
      {
        header: $translation("$vuetify.statistics.model.undelivered.title"),
        key: "undelivered",
        width: 18,
        style: { font: { name: "Calibri", size: 11 } }
      }
    ];

    // set font style on the header
    worksheet.getRow(1).font = { bold: true };

    // add data
    Vue._.each(sources, (source, k) => {
      worksheet.addRow({ date: k, ...source.total });
    });

    const totalValues = [total.total, total.delivered, total.undelivered];
    worksheet.addRow([
      $translation("$vuetify.statistics.model.total.title"),
      ...totalValues
    ]);

    const currentRow = worksheet.actualRowCount;

    worksheet.getCell(`A${currentRow}`).font = { bold: true };
    worksheet.fillFormula(
      `B${currentRow}:E${currentRow}`,
      `SUM(B2:B${currentRow - 1})`,
      totalValues
    );

    // download file
    try {
      const filename = `statistics-${date}`;
      await Utils.saveFile(filename, workbook);
    } catch (error) {
      console.log("file download failed", error);
    }
  };

  Utils.exportStatisticByMonthAndUser = async function(
    sources,
    $translation,
    month
  ) {
    const workbook = new Vue.$exceljs.Workbook({
      creator: "BulkSMS",
      lastModifiedBy: "BulkSMS",
      created: new Date(),
      modified: new Date()
    });

    Vue._.each(sources, source => {
      const worksheet = workbook.addWorksheet(source.date);

      worksheet.columns = [
        {
          header: $translation("$vuetify.statistics.model.username.title"),
          key: "username",
          style: { numFmt: "yyyy-mm-dd", font: { name: "Calibri", size: 11 } },
          width: 18
        },
        {
          header: $translation("$vuetify.statistics.model.sent.title"),
          key: "total",
          width: 18,
          style: { font: { name: "Calibri", size: 11 } }
        },
        {
          header: $translation("$vuetify.statistics.model.delivered.title"),
          key: "delivered",
          width: 18,
          style: { font: { name: "Calibri", size: 11 } }
        },
        {
          header: $translation("$vuetify.statistics.model.undelivered.title"),
          key: "undelivered",
          width: 18,
          style: { font: { name: "Calibri", size: 11 } }
        }
      ];

      worksheet.getRow(1).font = { bold: true };

      // add rows data
      Vue._.each(source.users, (count, username) => {
        const row = {
          username: username,
          total: count.total,
          delivered: Vue._.has(count, "delivered.total")
            ? count.delivered.total
            : 0
        };

        row.undelivered = parseInt(row.total) - parseInt(row.delivered);

        worksheet.addRow(row);
      });

      // add total
      const total = {
        username: $translation("$vuetify.statistics.model.total.title2"),
        total: source.total.total,
        delivered: Vue._.has(source, "total.delivered.total")
          ? source.total.delivered.total
          : 0
      };
      total.undelivered = parseInt(total.total) - parseInt(total.delivered);

      worksheet.addRow(total);

      const currentRow = worksheet.actualRowCount;

      worksheet.getCell(`A${currentRow}`).font = { bold: true };
      worksheet.fillFormula(
        `B${currentRow}:E${currentRow}`,
        `SUM(B2:B${currentRow - 1})`,
        [total.total, total.delivered, total.undelivered]
      );
    });

    // download file
    try {
      const filename = `statistics-users-${month}`;
      await Utils.saveFile(filename, workbook);
    } catch (error) {
      console.log("file download failed", error);
    }
  };

  Utils.exportCsvTemplateFile = async function() {
    const options = {
      formatterOptions: {
        delimiter: ";"
      }
    };
    const workbook = new Vue.$exceljs.Workbook();
    const worksheet = workbook.addWorksheet("Bulksms csv template");
    worksheet.addRow([
      parseFloat("237694124344"),
      "mysender",
      "hello bulksms user1"
    ]);
    worksheet.addRow([
      parseFloat("237679293431"),
      "mysender2",
      "hello bulksms user2"
    ]);

    // download file
    try {
      const filename = "bulksms-csv-template.csv";
      await Utils.saveFile(filename, workbook, "csv", "text/csv", options);
    } catch (error) {
      console.log("file download template", error);
    }
  };

  Utils.setTotalCount = function(input, source) {
    input.total += parseInt(source.total);
    input.delivered += parseInt(source.delivered);
    input.undelivered += parseInt(source.undelivered);
    return input;
  };

  Utils.setDataTelcoCount = function(source = {}, key) {
    const output = {
      total: 0,
      delivered: 0,
      undelivered: 0
    };

    output.total = Vue._.has(source, key) ? source[key] : 0;
    output.delivered = Vue._.has(source, `delivered.${key}`)
      ? source["delivered"][key]
      : 0;
    output.undelivered = output.total - output.delivered;

    return output;
  };

  Utils.setTotalSourceCount = function(input, source) {
    Vue._.each(source, (val, k) => {
      if (!Vue._.has(input, k)) {
        input[k] = parseInt(val);
      } else {
        input[k] += parseInt(val);
      }
    });
    return input;
  };

  Utils.saveFile = async function(
    filename,
    workbook,
    workbookType = "xlsx",
    type = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    options = { base64: true }
  ) {
    const xls64 = await workbook[workbookType].writeBuffer(options);
    Vue.$filesaver(
      new Blob([xls64], {
        type: type
      }),
      filename
    );
  };

  Utils.formatSize = function(size) {
    if (size > 1024 * 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + " TB";
    } else if (size > 1024 * 1024 * 1024) {
      return (size / 1024 / 1024 / 1024).toFixed(2) + " GB";
    } else if (size > 1024 * 1024) {
      return (size / 1024 / 1024).toFixed(2) + " MB";
    } else if (size > 1024) {
      return (size / 1024).toFixed(2) + " KB";
    }
    return size.toString() + " B";
  };

  Utils.formatKBSize = function(size) {
    const sizeBytes = parseFloat(size) * 1024;
    return Utils.formatSize(sizeBytes);
  };

  if (!Vue.$utils) {
    Vue.$utils = Utils;
    Object.defineProperties(Vue.prototype, {
      $utils: {
        get() {
          return Utils;
        }
      }
    });
  }
};

export default Utils;
